import React, { useEffect, useState } from "react";

import ResizeLogo from "../../../assets/images/ResizeLogo.jfif";
import OwlCarousel from "react-owl-carousel";
import AdminToolsDataService from "../../../services/admin-tools.service";
import { useDispatch, useSelector } from "react-redux";
import LoginService from "../../../services/login.service";
import { NotificationManager } from "react-notifications";
import { BlobToDownloadFile } from "../../../helper/commanFunction.js";
import { useTranslation } from "react-i18next";
import {
  setNewLoginData,
  setAdminLoginData,
  setCurrency,
  setCurrencySign,
} from "../../../actions/login/login";
import {
  setImpersonateHeaderMenuData,
  setAdminHeaderMenuData,
  setOpenKeyHeaderMenuData,
  setSelectSideMenu,
  setSelectedLanguage,
} from "../../../actions/headerMenu/headerMenu";
import { useNavigate } from "react-router-dom";
import { setChecklinkHeaderMenuData } from "../../../actions/headerMenu/headerMenu";
import LoginDataService from "../../../services/login.service";
import adminManageLanguageService from "../../../services/admin-manageLanguage.service";
import {
  setALLfilterValuesubmit,
  setFilterValuesubmit,
} from "../../../actions/manageCollection/manageCollection";
import NoImage from "../../../assets/images/No_Image.jpg";
import { useCookies } from "react-cookie";
import { Button, Modal, Select, Spin, Tooltip } from "antd";

const { Option } = Select;

const HasValidImage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const initialState = {
    clientTypeList: [
      {
        id: 1,
        value: "",
        label: t("All"),
      },
      {
        id: 2,
        value: "vendordiamond",
        label: t("Diamond Dealers"),
      },
      {
        id: 3,
        value: "retailer",
        label: t("Retailers"),
      },
      {
        id: 4,
        value: "vendor",
        label: t("Vendors"),
      },
    ],
    clientType: "",

    clientName: null,
    clientToolsData: {},
    userList: [],
    resetPasswordModal: false,
    viewProfileModal: false,
    viewProfileData: {},
    resetPasswordData: {
      dealerID: 0,
      name: "",
      id: "",
      userName: "",
      passwordHash: "",
      email: "",
      password: "",
      newPassword: "",
      confirmPassword: "",
    },
    resetPasswordError: {},
  };
  const [state, setState] = useState(initialState);
  const [viewProfileModal, setViewProfileModal] = useState(
    initialState.viewProfileModal
  );
  const [Data, setData] = useState([]);
  const [imageNameData, setImageNameData] = useState([]);
  const [resetPasswordModal, setResetPasswordModal] = useState(
    initialState.resetPasswordModal
  );
  const [clientNameList, setClientNameList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [loginDetails, setLoginDetails] = useState({});
  const [UserlistLoading, setUserlistLoading] = useState(false);
  const [impersonateLoading, setImpersonateLoading] = useState(false);
  const loginDetials = useSelector((state) => state.loginReducer);

  const AdminDetails = useSelector(
    (state) => state.headerMenuReducer.AdminMenuDetails
  );
  const ManageCollectionDetails = useSelector(
    (state) => state.manageCollectionReducer
  );
  const [viewProfileModalNoData, setViewProfileModalNoData] = useState(false);
  const [DealerId, setDealerId] = useState(null);
  const [mainSliderLoading, setMainSliderLoading] = useState(false);
  const [langcookies, setLangcookies] = useCookies(["lngCookie"]);

  const handleRunHasValidImage = async (dealerID) => {
    setLoading(true);
    try {
      // Step 1: Show "initiated" immediately
      NotificationManager.info(
        t("Process initiated. You will be notified upon completion.")
      );

      // Step 2: Call API (fire-and-forget)
      const response = await AdminToolsDataService.RunIsValidImageProcessing(
        dealerID
      );

      // Step 3: Delay showing result (fake completion)
      setTimeout(() => {
        if (response?.data?.message === "Success") {
          NotificationManager.success(t("Has Valid Image run successfully."));
        } else {
          NotificationManager.error(
            t(response?.data?.message || "Something went wrong.")
          );
        }
      }, 2000); // wait 5s before showing final result
    } catch (error) {
      console.error("RunHasValidImage error:", error);
      NotificationManager.error(t("Failed to run Has Valid Image."));
    } finally {
      setLoading(false);
    }
  };


  const expiryTime = new Date();
  expiryTime.setTime(expiryTime.getTime() + 3 * 60 * 60 * 1000); ///3 hours expiry time
  const domainSite = extractDomain();
  function extractDomain() {
    const url = window.location.href;
    const domainMatch = url.match(/:\/\/(www[0-9]?\.)?([^/:]+)/i);

    if (domainMatch && domainMatch.length > 2) {
      const fullDomain = domainMatch[2];
      const parts = fullDomain.split(".");
      if (parts.length >= 2) {
        const domain = "." + parts.slice(-2).join(".");
        return domain;
      }
    }

    return null;
  }
  useEffect(() => {
    if (loginDetials) {
      if (loginDetials.loginDetials) {
        if (loginDetials.loginDetials.responseData.logInSucceeded) {
          setLoginDetails(loginDetials.loginDetials.responseData);
          setDealerId(loginDetials.loginDetials.responseData.dealerId);
          handleGetUsersList(
            loginDetials.loginDetials.responseData.dealerId,
            "Retailer,Vendor"
          );
        }
      }
    }
  }, []);

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      clientTypeList: [
        {
          id: 1,
          value: "",
          label: t("All"),
        },
        {
          id: 2,
          value: "vendordiamond",
          label: t("Diamond Dealers"),
        },
        {
          id: 3,
          value: "retailer",
          label: t("Retailers"),
        },
        {
          id: 4,
          value: "vendor",
          label: t("Vendors"),
        },
      ],
    }));
  }, [t]);

  // show Password
  const handlePassShowHide = () => {
    setShowPassword(!showPassword);
  };
  const handlePassShowHide1 = () => {
    setShowPassword1(!showPassword1);
  };

  const handleGetUsersList = (id, type) => {
    let inputData = {
      clientType: type || "",
      dealerId: id,
    };
    setUserlistLoading(true);
    try {
      AdminToolsDataService.GetUsersList(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;

          if (message === "Success") {
            setClientNameList(responseData);
            setUserlistLoading(false);
          } else {
            setClientNameList([]);
            setUserlistLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setUserlistLoading(false);
        });
    } catch (error) {
      console.log(error);
      setUserlistLoading(false);
    }
  };
  const handleGetUsersListByDealerId = async () => {
    let inputData = {
      dealerID: state.clientName,
    };
    try {
      await AdminToolsDataService.GetUsersListByDealerId(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            if (responseData) {
              var tempState = state;
              tempState["clientToolsData"] = responseData[0];

              setState((prevState) => ({
                ...prevState,
                ...tempState,
              }));
            }
          } else {
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleImporsonateToJewelCloud = () => {
    let inputData = {
      dealerID: state.clientName,
    };
    try {
      AdminToolsDataService.ImporsonateToJewelCloud(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          setLoading(false);
          if (message === "Success") {
            var tempState = state;

            tempState["userList"] = responseData;
            tempState["resetPasswordData"] = responseData
              ? responseData[0]
              : null;

            tempState["resetPasswordData"]["newPassword"] = "";
            tempState["resetPasswordData"]["confirmPassword"] = "";
            setState((prevState) => ({
              ...prevState,
              ...tempState,
            }));
          } else {
            tempState["userList"] = null;
            tempState["resetPasswordData"] = null;
            setState((prevState) => ({
              ...prevState,
              ...tempState,
            }));
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  function onChange(e, name) {
    let tempState = state;

    if (e) {
      if (e.target) {
        if (name === "newPassword" || name == "confirmPassword") {
          tempState["resetPasswordData"][name] = e.target.value;
          tempState["resetPasswordError"][name] = "";
        } else {
          tempState[name] = e.target.value;
        }
      } else {
        if (name == "userId") {
          tempState["resetPasswordData"] = tempState.userList.filter(
            (x) => x.id == e
          )[0];
        } else if (name == "clientType") {
          tempState[name] = e;
          tempState["clientToolsData"] = null;
          tempState["clientName"] = null;
          setClientNameList([]);
        } else {
          tempState[name] = e;
        }
      }
    } else {
      tempState[name] = e;
      tempState["clientToolsData"] = null;
      tempState["clientName"] = null;
    }
    setState((prevState) => ({
      ...prevState,
      ...tempState,
    }));
    if (name == "clientType") {
      handleGetUsersList(DealerId, e);
    }
    if (name == "clientName") {
      setLoading(true);
      handleGetUsersListByDealerId();
      handleImporsonateToJewelCloud();
    }
    localStorage.setItem("AdminDetails", JSON.stringify(loginDetails));
    localStorage.setItem("FilterValue", ManageCollectionDetails.filterValue);
    localStorage.setItem(
      "AllFilterValue",
      ManageCollectionDetails.allFilterValue
    );
  }
  const handleImpersonateJewelCloud = () => {
    handleIdentifyLogin();
  };

  let navigate = useNavigate();

  const handleIdentifyLogin = async () => {
    let inputData = {
      userName: state.resetPasswordData.userName,
      password: state.resetPasswordData.newPassword,
      userId: state.resetPasswordData.id,
      userEmail: state.resetPasswordData.email,
      isImporsonate: true,
    };
    setImpersonateLoading(true);
    AdminToolsDataService.AdminToolsLogin(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        setLoading(false);
        if (message == "True") {
          localStorage.setItem("AdminDetails", JSON.stringify(loginDetails));
          var data = { responseData };
          localStorage.setItem(
            "HeaderMenuDetails",
            JSON.stringify(AdminDetails)
          );

          dispatch(setNewLoginData(data));
          handleGetFirstTierMenu(state.resetPasswordData.dealerID);
          handleAddLoginDetails(state.resetPasswordData.userName);
          handleCurrency(state.resetPasswordData.dealerID);

          handleLanguage(state.resetPasswordData.dealerID);
          setImpersonateLoading(false);
        } else {
          NotificationManager.error(t("Impersonating Data Failed"));
          setImpersonateLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
        setImpersonateLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleAddLoginDetails = (username) => {
    try {
      let inputData = {
        userName: username,
      };
      AdminToolsDataService.AddLoginDetails(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleCurrency = (id) => {
    let inputData = {
      delarId: id,
    };
    LoginDataService.currency(inputData).then((response) => {
      if (response.data.message === "Success") {
        let responseData = response.data.responseData;
        dispatch(setCurrency(responseData.currencyType));
        dispatch(setCurrencySign(responseData.currencysign));
      }
    });
  };
  const languageCodes = {
    Spanish: "es",
    English: "en",
    Arabic: "ar",
  };
  const handleLanguage = (id) => {
    let inputData = {
      delarId: id,
    };
    adminManageLanguageService
      .GetSelectlanguageForDelar(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          if (responseData) {
            const getLangValue = languageCodes[responseData.language] || null;
            dispatch(setCurrency(responseData.currencyType));
            dispatch(setSelectedLanguage(getLangValue));
            setLangcookies("lngCookie", getLangValue, {
              path: "/",
              expires: new Date(Date.now() + 86400000),
              domain: domainSite,
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleGetFirstTierMenu = (id) => {
    let inputData = {
      dealerId: id.toString(),
    };
    AdminToolsDataService.GetAllMenuDtlsByPermission(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          dispatch(setFilterValuesubmit("All"));
          dispatch(setALLfilterValuesubmit(""));
          dispatch(setImpersonateHeaderMenuData(responseData));
          dispatch(setChecklinkHeaderMenuData("Dashboard"));
          var url = window.location.origin + "/dashboard";
          window.open(url, "_blank");
        } else {
          NotificationManager.error(t("Impersonating Header Menu Failed"));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleReturnAdmin = () => {
    var responseData = JSON.parse(localStorage.getItem("AdminDetails"));
    var headerDetails = JSON.parse(localStorage.getItem("HeaderMenuDetails"));
    var filterValue = localStorage.getItem("FilterValue");
    var allFilterValue = localStorage.getItem("AllFilterValue");
    dispatch(setFilterValuesubmit(filterValue));
    dispatch(setALLfilterValuesubmit(allFilterValue));
    var data = { responseData };
    handleCurrency(responseData.dealerId);
    handleLanguage(responseData.dealerId);

    dispatch(setAdminLoginData(data));
    dispatch(setAdminHeaderMenuData(headerDetails));
    dispatch(setChecklinkHeaderMenuData("Admin"));
    handleGetUsersList(DealerId, "");
    setState((prevState) => ({
      ...prevState,
      ...initialState,
    }));
  };
  const handleAdminResetPassword = () => {
    if (handleResetPasswordValidation()) {
      let inputData = {
        userName: state.resetPasswordData.userName,
        password: state.resetPasswordData.newPassword,
      };
      LoginService.AdminResetPassword(inputData)
        .then((response) => {
          var message = response.data.message;
          if (message == "True") {
            NotificationManager.success(
              t("Password Has Been Reset Successfully")
            );
            handleResetModalCancel();
          } else {
            NotificationManager.error(t("Password Not Reset."));
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };
  const handleResetPasswordValidation = () => {
    var error = state.resetPasswordError;
    var resetData = state.resetPasswordData;
    var isValid = true;

    const strongRegex =
      /^(?=.*[a-z])(?!.* )(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{6,15})/;
    if (!resetData.newPassword) {
      error["newPassword"] = t("Please Enter Password.");
      isValid = false;
    } else if (!resetData.newPassword.match(strongRegex)) {
      isValid = false;
      error["newPassword"] = t(
        "Password Must contain Minimum 6 characters, Maximum 15 characters, at least one uppercase letter, one number and one special character and should not contain blank spaces"
      );
    } else if (resetData.newPassword.length > 15) {
      isValid = false;
      error["newPassword"] = t(
        "Password Must contain Minimum 6 characters, Maximum 15 characters, at least one uppercase letter, one number and one special character and should not contain blank spaces"
      );
    } else {
      error["newPassword"] = "";
    }
    if (!resetData.confirmPassword) {
      error["confirmPassword"] = t("Please Enter Confirm Password.");
      isValid = false;
    } else {
      error["confirmPassword"] = "";
    }
    if (resetData.confirmPassword && resetData.newPassword) {
      if (resetData.confirmPassword !== resetData.newPassword) {
        error["confirmPassword"] = t(
          "Password And Confirm Password Do Not Match."
        );
        isValid = false;
      } else {
      }
    }
    setState((prevState) => ({
      ...prevState,
      resetPasswordError: error,
    }));
    return isValid;
  };

  const handleResetModalCancel = () => {
    var tempState = state;
    tempState["resetPasswordData"]["newPassword"] = "";
    tempState["resetPasswordData"]["confirmPassword"] = "";
    tempState["resetPasswordError"] = {};

    setState((prevState) => ({
      ...prevState,
      ...tempState,
    }));
    setResetPasswordModal(false);
    setShowPassword(false);
    setShowPassword1(false);
  };
  const handleGetAdminDealerProfile = () => {
    let inputData = {
      dealerId: parseInt(state.clientName),
      vendorId: parseInt(state.clientName),
      dealerType: "",
    };
    setMainSliderLoading(true);

    AdminToolsDataService.GetAdminDealerProfile(inputData)
      .then((response) => {
        var message = response.data.message;
        var responseData = response.data.responseData;
        if (message === "Success") {
          setData(responseData);
          setImageNameData(responseData.adminDealerRetailerStoreImages);
          setViewProfileModal(true);
          setMainSliderLoading(false);
        } else {
          setData([]);
          setViewProfileModalNoData(true);
          setMainSliderLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setMainSliderLoading(false);
      })
      .finally(() => {
        setMainSliderLoading(false);
      });
  };
  const handleAdminToolsDownloadInventoryFile = () => {
    setLoading(true);
    let inputData = {
      dealerId: state.resetPasswordData.dealerID,
      dealerCompany: state.clientToolsData.dealerCompany,
    };
    AdminToolsDataService.AdminToolsDownloadInventoryFile(inputData)
      .then((response) => {
        var fileName =
          state.clientToolsData.dealerCompany +
          " ( " +
          state.clientToolsData.dealerId +
          " )" +
          "_" +
          new Date().toJSON().slice(0, 10).replace(/-/g, "") +
          ".xlsx";

        BlobToDownloadFile(response.data, fileName);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  /*Owl carousel options starts*/
  const options = {
    margin: 20,
    loop: true,
    responsiveClass: true,
    nav: true,
    dots: false,
    autoplay: true,
    autoplayTimeout: 2000,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1,
      },
      1200: {
        items: 1,
      },
    },
  };

  const openInNewTab = (websiteAddress) => {
    var url = websiteAddress;
    if (websiteAddress.includes("https")) {
      window.open(websiteAddress, "_blank");
    } else if (websiteAddress.includes("http")) {
      window.open(websiteAddress, "_blank");
    } else {
      window.open("https://" + websiteAddress, "_blank");
    }
  };
  /*Owl carousel options ends*/

  // Redirection
  const handleRedirection = () => {
    navigate("/vendorProfile", {
      state: {
        key: "Inventory",
        id: parseInt(state.clientName),
        checkTypeOfInventoryPage: "manageInventoryPage",
      },
    });
    dispatch(setChecklinkHeaderMenuData("My Catalog"));
    var MenuData = [`${"Data"}`, `${"DataConnection"}`];
    dispatch(setOpenKeyHeaderMenuData(MenuData));
  };

  const handleRedirectionLocation = () => {
    navigate("/companyLocation", {
      state: {
        id: parseInt(state.clientName),
      },
    });
    dispatch(setChecklinkHeaderMenuData("Profile"));
    var MenuData = [`${"company"}`];
    dispatch(setOpenKeyHeaderMenuData(MenuData));
    dispatch(setSelectSideMenu(["companyLocation"]));
  };

  const handleRedirectionBrands = () => {
    navigate("/manageBrands", {
      state: {
        id: parseInt(state.clientName),
      },
    });
    dispatch(setChecklinkHeaderMenuData("Profile"));
    var MenuData = [`${"company"}`];
    dispatch(setOpenKeyHeaderMenuData(MenuData));
    dispatch(setSelectSideMenu(["brand"]));
  };
  return (
    <React.Fragment>
      <div className="admintools__section">
        <div className="form__fields">
          <div className="row">
            <div className="col-lg-12">
              <h4 className="workarea__heading mt-0 mb-3">
                {t("Has Valid Image")}
              </h4>
            </div>

            <div className="col-lg-3 col-md-4">
              <div className="input__block">
                <label>
                  {" "}
                  {t("Client Name")} <span>*</span>
                </label>
                <Select
                  showSearch
                  className="border__grey"
                  placeholder={t("Select Client Name")}
                  optionFilterProp="children"
                  value={state.clientName}
                  onChange={(e) => {
                    onChange(e, "clientName");
                  }}
                  loading={UserlistLoading}
                >
                  <Option key={0} value="">
                    {t("Select Client Name")}
                  </Option>
                  {clientNameList.map((item) => {
                    return (
                      <Option value={item.dealerID}>
                        {item.dealerCompany + " (" + item.dealerID + ")"}
                      </Option>
                    );
                  })}
                </Select>
              </div>
            </div>

            <div className="col-lg-3 col-md-8 col-lg-8 text-left mt-4 mobile-mt-0 text-left-mobile">
              <button
                className="primary-btn"
                onClick={() => handleRunHasValidImage(state.clientName)}
              >
                {t("Run Has Valid Image")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default HasValidImage;
